"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppVersion = void 0;

var AppVersion =
/** @class */
function () {
  function AppVersion(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - appVersionId
   * @return Promise|Observable|any
   */


  AppVersion.prototype.GetAppVersion = function (appVersionId) {
    return this.restClient.get('AppVersion/UseCase/GetAppVersion', {
      appVersionId: appVersionId
    });
  };
  /**
   * @param string - appVersionType check-in-ios|check-in-android|ticket-block-mgmt-ios|ticket-block-mgmt-android|efx-ios|efx-android|events-ios|events-android|leads-flutter
   * @return Promise|Observable|any
   */


  AppVersion.prototype.GetAppVersionByType = function (appVersionType) {
    return this.restClient.get('AppVersion/UseCase/GetAppVersionByType', {
      appVersionType: appVersionType
    });
  };
  /**
   * @return Promise|Observable|any
   */


  AppVersion.prototype.GetSystemStatus = function () {
    return this.restClient.get('AppVersion/UseCase/GetSystemStatus', {});
  };
  /**
   * @return Promise|Observable|any
   */


  AppVersion.prototype.ListAppVersions = function () {
    return this.restClient.get('AppVersion/UseCase/ListAppVersions', {});
  }; // Commands

  /**
   * @param string - appVersionType check-in-ios|check-in-android|ticket-block-mgmt-ios|ticket-block-mgmt-android|efx-ios|efx-android|events-ios|events-android|leads-flutter
   * @param string - softVersion
   * @param string - hardVersion
   * @return Promise|Observable|any
   */


  AppVersion.prototype.SetAppVersionNumberByType = function (appVersionType, softVersion, hardVersion) {
    return this.restClient.post('AppVersion/UseCase/SetAppVersionNumberByType', {
      appVersionType: appVersionType,
      softVersion: softVersion,
      hardVersion: hardVersion
    });
  };

  return AppVersion;
}();

exports.AppVersion = AppVersion;